import React from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { getPlatformType } from 'src/components/utils/Helper';
import { AmplitudeButton } from 'src/components/container/AmplitudeButton';
import styles from './BrowserDownloadButton.module.scss';

const browserButtonMap: {
  [browser: string]: { link: { [platform: string]: string }; copyKey: string; logoKey: string };
} = {
  'Google Chrome': {
    link: {
      desktop: 'https://www.google.com/chrome/browser/desktop/index.html',
      mobile: 'https://play.google.com/store/apps/details?id=com.android.chrome',
    },
    copyKey: 'GOOGLE_CHROME_BROWSER',
    logoKey: 'chrome',
  },
  'Microsoft Edge': {
    link: { desktop: 'https://www.microsoft.com/en-in/windows/microsoft-edge' },
    copyKey: 'MICROSOFT_EDGE_BROWSER',
    logoKey: 'edge',
  },
  'Mozilla Firefox': {
    link: { desktop: 'https://www.mozilla.org/en-US/exp/firefox/' },
    copyKey: 'FIREFOX_BROWSER',
    logoKey: 'firefox',
  },
  Safari: {
    link: { desktop: 'https://support.apple.com/en-us/HT204416', mobile: 'https://support.apple.com/en-us/HT204204' },
    copyKey: 'SAFARI_BROWSER',
    logoKey: 'safari',
  },
  'Samsung Internet': {
    link: { mobile: 'https://play.google.com/store/apps/details?id=com.sec.android.app.sbrowser&hl=en' },
    copyKey: 'SAMSUNG_INTERNET',
    logoKey: 'samsung',
  },
  Opera: {
    link: { desktop: 'https://www.opera.com/download' },
    copyKey: 'OPERA_BROWSER',
    logoKey: 'opera',
  },
};

const getBrowserDownloadLink = (browserKey: string) => {
  const browser = browserButtonMap[browserKey];
  const platform = getPlatformType();
  return platform in browser.link ? browser.link[platform] : browser.link['desktop'];
};

interface BrowserButtonProps {
  browserKey: string;
  pageName: string;
}

const BrowserDownloadButton: React.FC<BrowserButtonProps> = ({ browserKey, pageName }) => {
  const { t } = useTranslation();
  const browser = browserButtonMap[browserKey];
  return (
    <AmplitudeButton
      action="DownloadBrowser"
      eventProperties={{ 'Common::BrowserName': browserKey }}
      pageName={pageName}
      className={styles.browserButton}
      variant="outline"
      onClick={() => {
        window.open(getBrowserDownloadLink(browserKey));
      }}
    >
      <div className={styles.logoContainer}>
        <span className={cx(styles[`${browser.logoKey}Logo`], styles.browserLogo)}></span> {t(browser.copyKey)}
      </div>
    </AmplitudeButton>
  );
};

export default BrowserDownloadButton;
